/** Sichtbarer Hinweis, solange ein Live-Deploy die API neu startet. */
export const SERVER_UPDATE_MESSAGE =
  "Die App wird gerade aktualisiert. Bitte einen Moment warten, das ist kein Fehler.";

/** Hängengebliebene Statusdatei nach einem abgebrochenen Deploy nicht ewig anzeigen. */
export const SERVER_UPDATE_MAX_AGE_MS = 20 * 60 * 1000;

export interface MaintenanceStatusBody {
  active?: boolean;
  message?: string;
  started_at?: string;
}

export type MaintenancePollOutcome =
  | { kind: "active"; message: string; startedAt: string | null }
  | { kind: "inactive" }
  | { kind: "keep" };

function startedAtMs(value: string | undefined): number | null {
  if (!value) return null;
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : null;
}

export function isStaleMaintenanceStart(
  startedAt: string | undefined,
  now = Date.now(),
): boolean {
  const ms = startedAtMs(startedAt);
  if (ms == null) return false;
  return now - ms > SERVER_UPDATE_MAX_AGE_MS;
}

/**
 * Auswertung von GET /maintenance-status.
 *
 * 200 mit active zeigt die Update-Anzeige. 200 ohne active und 404 blenden sie aus
 * (Datei weg, Server antwortet). 502/503/504 und Netzwerkfehler behalten den
 * bisherigen Zustand, damit die Anzeige den Neustart überbrückt.
 */
export function interpretMaintenancePoll(
  status: number,
  body: MaintenanceStatusBody | null,
  now = Date.now(),
): MaintenancePollOutcome {
  if (status === 200 && body?.active === true) {
    if (isStaleMaintenanceStart(body.started_at, now)) return { kind: "inactive" };
    const message = (body.message || "").trim() || SERVER_UPDATE_MESSAGE;
    return { kind: "active", message, startedAt: body.started_at ?? null };
  }
  if (status === 200 || status === 404) return { kind: "inactive" };
  return { kind: "keep" };
}

export function isConnectivityFailureMessage(message: unknown): boolean {
  return (
    typeof message === "string" &&
    /nicht erreichbar|Netzwerkfehler|Zeitüberschreitung|Bad Gateway|Service Unavailable|Gateway Time-?out|\b502\b|\b503\b|\b504\b/i.test(
      message,
    )
  );
}
